import type { ReactNode } from 'react'

import { sanitizeUserFacingErrorMessage } from '../../lib/userFacingErrorMessage'
import type { ThemeId } from '../../theme/ThemeContext'
import { ChromePrimaryButton } from '../ChromeActions'
import { PageCenteredPlaceholder } from './PageCenteredPlaceholder'

type Props = {
  theme: ThemeId
  title: string
  detail?: string
  onRetry?: () => void
  retryLabel?: string
  illustration?: ReactNode
  action?: ReactNode
  className?: string
}

/**
 * 页面级异步失败：占满主列并垂直居中，无虚线卡片框（与空状态同级）。
 */
export function PageAsyncErrorState({
  theme,
  title,
  detail,
  onRetry,
  retryLabel = '重试',
  illustration,
  action,
  className,
}: Props) {
  const terminalish = theme === 'geek'
  const safeDetail = detail ? sanitizeUserFacingErrorMessage(detail) : ''

  return (
    <PageCenteredPlaceholder role="alert" aria-live="polite" className={className}>
      {illustration}
      <h2
        className={[
          'typo-lib-section font-semibold text-ink',
          terminalish ? 'font-mono tracking-tight' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {title}
      </h2>
      {safeDetail ? (
        <p className="text-pretty text-sm leading-relaxed text-ink-soft">{safeDetail}</p>
      ) : null}
      {action ??
        (onRetry ? (
          <ChromePrimaryButton type="button" shape="rounded" onClick={onRetry}>
            {retryLabel}
          </ChromePrimaryButton>
        ) : null)}
    </PageCenteredPlaceholder>
  )
}
